var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 6.333a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333zM28 9c.16 0 .31-.038.444-.104A3.668 3.668 0 0 0 35.667 8a3.667 3.667 0 0 0-7.223-.897A.996.996 0 0 0 28 7h-8a1 1 0 0 0-1 1v3.333a1 1 0 1 0 2 0V9h7zm-8 18.666a1 1 0 0 1 1 1V31h7c.16 0 .31.037.444.103a3.668 3.668 0 0 1 7.223.897 3.667 3.667 0 0 1-7.223.896A.996.996 0 0 1 28 33h-8a1 1 0 0 1-1-1v-3.334a1 1 0 0 1 1-1zM23.667 20A1.667 1.667 0 1 1 27 20a1.667 1.667 0 0 1-3.333 0zm1.666-3.667a3.667 3.667 0 1 0 0 7.333 3.667 3.667 0 0 0 0-7.333zm6.667 14a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333zM13 14a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.50bc57e185d3d6ab0d834eaa7a97336d.svg";
export { ForwardRef as ReactComponent };